import type { ExperimentKey, FuncExperimentDef } from '../types';
import { mountFamilyZoo } from './family-zoo';
import { mountTransformations } from './transformations';
import { mountComposition } from './composition';
import { mountInverses } from './inverses';
import { mountDomainRangeLab } from './domain-range-lab';
import { mountBehaviorAndFeatures } from './behavior-and-features';
import { mountPiecewiseBuilder } from './piecewise-builder';
import { mountRepresentations } from './representations';

export const EXPERIMENTS: Record<ExperimentKey, FuncExperimentDef> = {
  'family-zoo': {
    labelKey: 'experiment.family-zoo.label',
    params: [],
    mount: mountFamilyZoo,
  },
  transformations: {
    labelKey: 'experiment.transformations.label',
    params: [],
    mount: mountTransformations,
  },
  composition: {
    labelKey: 'experiment.composition.label',
    params: [],
    mount: mountComposition,
  },
  inverses: {
    labelKey: 'experiment.inverses.label',
    params: [],
    mount: mountInverses,
  },
  'domain-range-lab': {
    labelKey: 'experiment.domain-range-lab.label',
    params: [],
    mount: mountDomainRangeLab,
  },
  'behavior-and-features': {
    labelKey: 'experiment.behavior-and-features.label',
    params: [],
    mount: mountBehaviorAndFeatures,
  },
  'piecewise-builder': {
    labelKey: 'experiment.piecewise-builder.label',
    params: [],
    mount: mountPiecewiseBuilder,
  },
  representations: {
    labelKey: 'experiment.representations.label',
    params: [],
    mount: mountRepresentations,
  },
};
